import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ButtonImg from './button_img';
import '../style.css';
import { useAuth0 } from "@auth0/auth0-react";


function Navbar({ currLang, langButtonHandle }) {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">{currLang === "IS" ? "Magnea og Ásbjörn" : "Magnea and Ásbjörn"}</Link>
      <button
        className="hamburger"
        onClick={() => setMenuOpen((open) => !open)}
        aria-label="Toggle menu"
      ><span />
        <span />
        <span />
      </button>
      <div className={`nav-links ${menuOpen ? "open" : ""}`}>
        <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>{currLang === "IS" ? "Heim" : "Home"}</Link>
        <Link to="/gisting" className="nav-link" onClick={() => setMenuOpen(false)}>{currLang === "IS" ? "Gisting" : "Accomodation"}</Link>
        <Link to="/newsletter" className="nav-link" onClick={() => setMenuOpen(false)}>{currLang === "IS" ? "Fréttabréf" : "Newsletters"}</Link>
        {/* <Link to="/contact" className="nav-link">{currLang === "IS" ? "Hafa samband" : "Contact"}</Link> */}
        <Link to="/rsvp" className="nav-link" onClick={() => setMenuOpen(false)}>{currLang === "IS" ? "RSVP" : "RSVP"}</Link>
        <Link to="/gallery" className="nav-link" onClick={() => setMenuOpen(false)}>{currLang === "IS" ? "Myndir" : "Gallery"}</Link>
        <ButtonImg
          imageUrl={currLang === "IS" ? "/flag-icons/flags/4x3/gb.svg" : "/flag-icons/flags/4x3/is.svg"}
          className={"lang-button"}
          onClick={langButtonHandle}
        />
        {/*</div>
      <div className="auth-buttons">*/}
        {isAuthenticated ? (
          <>
            {/*<span>{currLang === "IS" ? "Velkomin, " : "Welcome, "}{user && user.name} </span>*/}
            <button className="login-button" onClick={() => { logout({ logoutParams: { returnTo: window.location.origin } }); setMenuOpen(false); }}>
              {currLang === "IS" ? "Skrá út" : "Logout"}
            </button>
          </>
        ) : (
          <button className="login-button" onClick={() => { loginWithRedirect({ appState: { returnTo: window.location.pathname } }); setMenuOpen(false); }}>{currLang === "IS" ? "Skrá inn" : "Login"}</button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;